// extracted by mini-css-extract-plugin
export default {"tile":"Calendar_tile__y9RUt","day":"Calendar_day__wwsbK","today":"Calendar_today__E7GpH","difference":"Calendar_difference__a5g0k"};